import styled from "styled-components";
import tw from "twin.macro";

export const StyledTestimonial = styled.div`
  ${tw`mx-auto`}
  ${({ theme }) => theme.media["max:sm"]} {
    ${tw`px-6`}
  }
  ${({ theme }) => theme.media["max:md"]} {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .img-container {
    ${tw`mx-auto relative`}
    border-radius: 12px;
    margin-bottom: -3rem;
    background: gray;
    height: 125px;
    width: 180px;
    z-index: 2;
    overflow: hidden;
  }
  .copy-container {
    ${tw`bg-white text-center flex flex-col justify-center`}
    border-radius: 12px;
    border: 1px solid #e5e5e5;
    padding: 5rem 2rem 2rem;
    height: 350px;

    .quote {
      ${tw`mb-4 text-textGray-darker`}
      line-height: 23px;
    }
  }

  ${({ theme }) => theme.media["sm"]} {
    .img-container {
      height: 160px;
      width: 232px;
    }

    .copy-container {
      height: 300px;
    }
  }

  ${({ theme }) => theme.media["md"]} {
    width: 600px;
    padding-left: 4rem;

    .slide {
      ${tw`py-8 bg-white flex items-center`}
      border-radius: 12px;
      border: 1px solid #e5e5e5;
    }
    .img-container {
      width: 220px;
      height: 240px;
      flex-shrink: 0;
      margin-bottom: unset;
      margin-left: -4rem;
    }
    .copy-container {
      ${tw`flex flex-col justify-center`}
      text-align: left;
      border: none;
      padding-top: 2rem;
      height: 300px;
    }
  }

  ${({ theme }) => theme.media["lg"]} {
    ${tw`items-stretch`}
    width: 730px;
    padding-left: unset;
    .slide {
      padding: unset;
      display: grid;
      grid-template-columns: 1fr 1fr;
      overflow: hidden;
      justify-content: center;
      height: 440px;
      border: none;
    }

    .img-container {
      margin-left: unset;
      height: 100%;
      width: 100%;
      border-radius: unset;
    }

    .copy-container {
      ${tw`flex flex-col justify-center h-full`}
      padding: 1rem 3rem;
      font-size: 19px;
      border-radius: 0 20px 20px 0;
      border: 1px solid #e5e5e5;
      .quote {
        line-height: 28px;
      }
    }
  }
`;
